import { createRouter, createWebHistory } from 'vue-router'

import { isAuthenticated } from '@/libs/auth'

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) return savedPosition
        else if (to.hash) return { selector: to.hash }
        else if (from.path === to.path) return {}

        return {
            top: 1,
            behavior: 'smooth'
        }
    },
    routes: [
        {
            path: '/',
            name: 'dashboard',
            component: () => import('@/views/Dashboard.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/admin-users',
            name: 'admin-users',
            component: () => import('@/views/adminUser/AdminUsers.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/users',
            name: 'users',
            component: () => import('@/views/user/Users.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/task-types',
            name: 'task-types',
            component: () => import('@/views/taskType/TaskTypes.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/tasks',
            name: 'tasks',
            component: () => import('@/views/task/Tasks.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/login',
            name: 'login',
            component: () => import('@/views/Login.vue'),
            meta: {
                layout: 'Blank',
                requiresAuth: false
            }
        },
        {
            path: '/:pathMatch(.*)*',
            redirect: '/'
        }
    ]
})

router.beforeEach((to, from, next) => {
    const loggedIn: boolean = isAuthenticated()

    if (loggedIn && to.name === 'login') {
        next({ name: 'dashboard' })
        return
    }

    if (to.meta.requiresAuth && !loggedIn) {
        next({ name: 'login' })
        return
    }

    next()
})

export default router
